import React from 'react';
import EmptyStateIcon, {
  EmptyStateWrapper,
  NO_DATA_FOR_PERIOD_MESSAGE,
} from 'components/_common/EmptyState';
import { Box } from '@mui/material';
import { notUndefiend, valueAsString } from 'helpers/conversions';
import { StatsData } from '../Card';
import { dashboardIcon } from '../Icons';
import { Spinner } from '../Styles';
import { TimeFrameEnum } from 'models/ReportData';
import { getDescriptionTextForCustomTimeframe } from 'helpers/overviewUtils';
import { CardProps } from './DesktopTopCards.types';
import { dtfStyles as styles } from './DesktopAvarageProductionRateCard.styles';
import { animations } from 'theme';
import { styles as topCardStyles } from './DesktopTotalImpressionCard.styles';

const DesktopAverageProductionRateCardDtf = (props: CardProps) => {
  const {
    stats,
    description,
    value,
    units,
    statsDescription,
    timeframe,
    customTimeframeProperties,
  } = props;
  const isNegative = React.useMemo(() => {
    if (!notUndefiend([stats])) {
      return false;
    }
    if (stats! < 0) {
      return true;
    }
    if (description === 'Average Availability' && value !== undefined && value >= 0.999) {
      return false;
    }
    return false;
  }, [description, stats, value]);

  if (value === null) {
    return (
      <EmptyStateWrapper>
        <EmptyStateIcon icon="no-icon" message={NO_DATA_FOR_PERIOD_MESSAGE} />
      </EmptyStateWrapper>
    );
  }

  return notUndefiend([value]) ? (
    <Box
      display="flex"
      justifyContent="space-between"
      width="100%"
      height="100%"
      boxSizing="border-box"
      sx={{
        //*vertical padding in px - see the note in DesktopTotalImpressionCard.styles.ts (a % padding is width-relative and breaks row alignment)
        padding: '12px 4%',
        borderRadius: 'inherit',
        ...animations.appearanceEffect,
        '@media (min-width: 2250px)': {
          padding: '12px 1%',
        },
      }}
      data-testid="average-production-rate-card">
      <Box
        display="flex"
        boxSizing="border-box"
        height="100%"
        width="100%"
        sx={styles.leftColumn}
        data-testid="left-column">
        <Box
          display="flex"
          flexDirection="column"
          boxSizing="border-box"
          width="100%"
          height="100%"
          sx={styles.leftColumnCardContent}
          data-testid="left-column-content">
          <Box
            display="flex"
            flexDirection="column"
            boxSizing="border-box"
            width="100%"
            height="80px"
            sx={styles.upperRow}
            data-testid="upper-row">
            <Box display="flex" alignItems="flex-start" data-testid="upper-row-content">
              {isNegative ? dashboardIcon.negative : dashboardIcon.positive}{' '}
              <Box sx={topCardStyles.value} data-testid="avg-prod-rate-value">
                {valueAsString(value, false)}
              </Box>
              <Box sx={topCardStyles.units} data-testid="avg-prod-rate-units">
                {units}
              </Box>
            </Box>
            <Box
              sx={[topCardStyles.description, { paddingTop: '2px' }]}
              data-testid="avg-prod-rate-description">
              {description}
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="flex-end"
            width="100%"
            height="100%"
            boxSizing="border-box"
            sx={topCardStyles.bottomRow}
            data-testid="bottom-row">
            {notUndefiend([stats]) && StatsData(stats!)}{' '}
            <div>
              {timeframe === TimeFrameEnum.custom
                ? getDescriptionTextForCustomTimeframe({ timeframe, customTimeframeProperties })
                : statsDescription}
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  ) : (
    Spinner(60)
  );
};
export default DesktopAverageProductionRateCardDtf;
